
import { CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ResizableSwappableCard } from "./ResizableSwappableCard";

interface NotableUsersCardProps {
  userWithMostContracts: { name: string; count: number };
  userWithHighestValue: { name: string; value: number };
  rearrangingEnabled?: boolean;
  onRemove?: (id: string) => void;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  onResize?: (id: string, newSize: 'small' | 'medium' | 'large' | 'xlarge') => void;
}

export function NotableUsersCard({ 
  userWithMostContracts, 
  userWithHighestValue, 
  rearrangingEnabled = false,
  onRemove,
  size = 'medium',
  onResize
}: NotableUsersCardProps) {
  return (
    <ResizableSwappableCard 
      id="notable-users" 
      size={size}
      showHandle={rearrangingEnabled}
      showResizeControl={rearrangingEnabled}
      onRemove={rearrangingEnabled ? onRemove : undefined}
      onResize={onResize ? (newSize) => onResize("notable-users", newSize) : undefined}
    >
      <CardHeader>
        <CardTitle>Notable Users</CardTitle>
        <CardDescription>Users with the most significant impact</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="flex justify-between items-center">
            <div>
              <h4 className="text-sm font-medium">Most Contracts</h4>
              <p className="text-2xl font-bold">{userWithMostContracts.name}</p>
            </div>
            <Badge variant="outline" className="text-md">
              {userWithMostContracts.count} contracts
            </Badge>
          </div>
          <div className="flex justify-between items-center">
            <div>
              <h4 className="text-sm font-medium">Highest Contract Value</h4>
              <p className="text-2xl font-bold">{userWithHighestValue.name}</p>
            </div>
            <Badge variant="outline" className="text-md">
              ${userWithHighestValue.value.toLocaleString()}
            </Badge>
          </div>
        </div>
      </CardContent>
    </ResizableSwappableCard>
  );
}
